import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CustomAttributesEditing from './customattributesediting';

export default class CustomAttributes extends Plugin {
  static get requires() {
    return [ CustomAttributesEditing ];
  }

  static get pluginName() {
    return 'CustomAttributes';
  }
}
